import React from 'react';
import './ShutdownPage.css';

const SUPERTOKENS_URL = 'https://supertokens.com';

const ShutdownPage: React.FC = () => {
  return (
    <main className="shutdown-page">
      <div className="shutdown-page__content">
        <img className="shutdown-page__logo" src="/images/rownd-logo.svg" alt="Rownd" />
        <span className="shutdown-page__eyebrow">A note from the Rownd team</span>
        <h1 className="shutdown-page__title">Thank you for building with Rownd</h1>
        <p className="shutdown-page__lead">
          The Rownd platform has been retired and this dashboard is no longer available. We&apos;re
          grateful to every team that trusted us with their users&apos; sign-in experience.
        </p>

        <section className="shutdown-page__card">
          <h2 className="shutdown-page__card-title">Still need authentication?</h2>
          <p className="shutdown-page__card-text">
            We&apos;ve partnered with SuperTokens to keep your users signing in smoothly. Their team
            can help you migrate and get up and running.
          </p>
          <a className="shutdown-page__cta" href={SUPERTOKENS_URL} target="_blank" rel="noreferrer">
            Contact SuperTokens
            <span aria-hidden="true">→</span>
          </a>
        </section>
      </div>

      <p className="shutdown-page__footer">With gratitude, the Rownd team</p>
    </main>
  );
};

export default ShutdownPage;
